import { unwrap } from '@hive/api';
import { Modal, Note, ProblemBox, TextAreaField, useToast } from '@hive/ui';
import { useState } from 'react';
import { useI18nP } from '../../i18n';
import { useSession } from '../../lib/session';

/** Puxar ou soltar o freio de emergência (O1), sempre com motivo. */
export function BrakeModal({ active, onClose }: { active: boolean; onClose: (done: boolean) => void }) {
  const { t } = useI18nP();
  const s = useSession();
  const toast = useToast();
  const [reason, setReason] = useState('');
  const [err, setErr] = useState<unknown>(null);
  const go = async () => {
    try {
      await unwrap(s.api.POST(active ? '/api/v1/emergency-brake/release' : '/api/v1/emergency-brake/pull', { body: { reason } }));
      toast(active ? t('brake.released') : t('brake.pulled'), { kind: active ? 'ok' : 'warn' });
      onClose(true);
    } catch (e) {
      setErr(e);
    }
  };
  return (
    <Modal
      title={active ? t('brake.release') : t('brake.pull')}
      onClose={() => onClose(false)}
      foot={
        <>
          <button type="button" className="btn" onClick={() => onClose(false)}>
            {t('ham.cancel')}
          </button>
          <button type="button" className={active ? 'btn btn-primary' : 'btn btn-danger'} disabled={reason.trim().length < 5} onClick={go}>
            {active ? t('brake.release') : t('brake.pull')}
          </button>
        </>
      }
    >
      <div className="stack">
        <Note tone={active ? 'info' : 'warn'}>{active ? t('brake.releaseText') : t('brake.pullText')}</Note>
        <TextAreaField label={t('brake.reason')} hint={t('brake.reasonHint')} value={reason} onChange={setReason} rows={3} />
        {err != null && <ProblemBox error={err} />}
      </div>
    </Modal>
  );
}
